<template>
  <div class="admin-suggestion-detail" v-loading="loading">
    <page-title title="处理状态">
      <div class="form-item">
        <span class="form-item-label">处理状态：</span>
        <div class="form-item-content">
          <template v-if="state === 'TO_HANDLE'">
            <i class="el-icon-circle el-icon-remove-outline" style="background-color:#C1C4C7"></i>
            <span style="color:#C1C4C7">未处理</span>
          </template>
          <template v-else>
            <i class="el-icon-circle el-icon-circle-check" style="background-color:#005BFF"></i>
            <span style="color:#005BFF">已处理</span>
          </template>
        </div>
      </div>
    </page-title>
    <page-title title="意见详情">
      <ul class="info-form">
        <li class="form-item form-double-item">
          <span class="form-item-label">用户类型：</span>
          <div class="form-item-content">
            <span v-if="feedData.userType === 'SELLER'">卖家</span>
            <span v-else-if="feedData.userType === 'BUYERS'">买家</span>
            <span v-else-if="feedData.userType === 'TOURIST'">游客</span>
            <span v-else> - - </span>
          </div>
          <span class="form-item-label">用户昵称：</span>
          <div class="form-item-content">
            <i
              v-if="feedData.userType === 'SELLERS'"
              class="el-icon-circle el-icon-s-shop"
              style="background-color:#005bff;"
            ></i>
            <i
              v-else-if="feedData.userType === 'BUYERS'"
              class="el-icon-circle el-icon-user-solid"
              style="background-color:#00bd83;"
            ></i>
            <span>{{ userInfo.nickname || '- -' }}</span>
          </div>
        </li>
        <li class="form-item form-double-item">
          <span class="form-item-label">意见类型：</span>
          <div class="form-item-content">
            {{ OPINIONTYPE_ZH[feedData.opinionType] || '- -' }}
          </div>
          <span class="form-item-label">提交时间：</span>
          <div class="form-item-content">
            {{ feedData.createdDate }}
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">意见内容：</span>
          <div class="form-item-content description">
            <span>{{ feedData.content }}</span>
            <div class="img-list" v-if="feedData.mediaItems">
              <img v-for="m in feedData.mediaItems" v-pic="m.location" :key="m.id" v-preview />
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-item-label">联系方式：</span>
          <div class="form-item-content">
            {{ feedData.phone || '- -' }}
          </div>
        </li>
      </ul>
    </page-title>
    <page-title title="处理">
      <div class="form-item">
        <span class="form-item-label" style="width:auto;">备注（仅工作人员可见）：</span>
        <div class="form-item-content">
          <el-input
            :disabled="state === 'HANDLED'"
            v-model="remarks"
            placeholder="备注"
            type="textarea"
            resize="none"
            rows="5"
          ></el-input>
        </div>
      </div>
      <div class="btn-grp" v-if="state === 'TO_HANDLE'">
        <el-button @click="handle">已处理</el-button>
        <el-button @click="$router.replace('/suggestion')">关闭</el-button>
      </div>
    </page-title>
  </div>
</template>
<script>
import PageTitle from '@/components/pageTitle';
import { getFeedbackById, handleFeedbackById } from '@/api/req';
import { OPINIONTYPE_ZH } from './_eum';
export default {
  components: { PageTitle },
  name: 'suggestionDetail',
  data() {
    return {
      loading: true,
      remarks: '',
      feedData: {}
    };
  },
  computed: {
    suggestionId() {
      return this.$route.params.id;
    },
    state() {
      return this.feedData.state;
    },
    OPINIONTYPE_ZH: () => OPINIONTYPE_ZH,
    userInfo() {
      return this.feedData.userInfo || {}
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$ajax
        .get(getFeedbackById(this.suggestionId))
        .then(({ data }) => {
          this.feedData = Object.freeze(data);
          this.remarks = data.remarks;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    handle() {
      if(!this.remarks) {
        this.$message.info('请填写备注信息');
        return;
      }
      this.$confirm('确定处理掉该条意见反馈?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax
          .put(handleFeedbackById(this.suggestionId), {
            remarks: this.remarks
          })
          .then(res => {
            this.$message.success('处理成功');
            this.getData();
          })
          .catch(err => {
            this.$message.info('处理失败');
          });
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss">
.admin-suggestion-detail {
  .info-form {
    // padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
  }
  .form-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }
    &-label {
      width: 64px;
      height: 20px;
      font-size: 12px;
      font-weight: 500;
      color: #8998a0;
      line-height: 20px;
      margin-right: 6px;
      align-self: flex-start;
    }
    &-content.description {
      line-height: 20px;
      word-break: break-all;
      img {
        margin-top: 20px;
        height: 78px;
        width: 78px;
        border-radius: 4px;
        font-size: 0;
        vertical-align: bottom;
        margin-right: 8px;
        object-fit: contain;
      }
    }
    &-content {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      color: #040b28;
      line-height: 20px;
      max-width: 700px;
      .el-icon-circle {
        margin-right: 8px;
        color: #fff;
        vertical-align: middle;
      }
    }
  }
  .form-double-item {
    .form-item-content {
      max-width: 300px;
    }
  }
  .btn-grp {
    padding: 30px 0 0;
    background-color: white;
    border-radius: 4px;
    .el-button {
      padding: 13px 30px;
      border-color: #002b9c;
      color: #002b9c;
      &:not(.is-disabled):hover {
        background-color: #002b9c;
        color: white;
      }
    }
    .is-disabled {
      border: 1px dashed #8998a0;
      color: #8998a0;
    }
  }
}
</style>
